/* @generated */
// prettier-ignore
if (Intl.ListFormat && typeof Intl.ListFormat.__addLocaleData === 'function') {
  Intl.ListFormat.__addLocaleData({
    "data": {
      "es-419": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-AR": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-BO": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-BR": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-BZ": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-CL": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-CO": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-CR": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-CU": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-DO": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} y {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-EA": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-EC": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-GQ": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-GT": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-HN": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-IC": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-MX": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-NI": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-PA": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-PE": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-PH": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-PR": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-PY": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-SV": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-US": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-UY": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es-VE": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      },
      "es": {
        "conjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          }
        },
        "disjunction": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          },
          "narrow": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} o {1}",
            "pair": "{0} o {1}"
          }
        },
        "unit": {
          "long": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0} y {1}",
            "pair": "{0} y {1}"
          },
          "short": {
            "start": "{0}, {1}",
            "middle": "{0}, {1}",
            "end": "{0}, {1}",
            "pair": "{0} y {1}"
          },
          "narrow": {
            "start": "{0} {1}",
            "middle": "{0} {1}",
            "end": "{0} {1}",
            "pair": "{0} {1}"
          }
        }
      }
    },
    "availableLocales": ["es-419", "es-AR", "es-BO", "es-BR", "es-BZ", "es-CL", "es-CO", "es-CR", "es-CU", "es-DO", "es-EA", "es-EC", "es-GQ", "es-GT", "es-HN", "es-IC", "es-MX", "es-NI", "es-PA", "es-PE", "es-PH", "es-PR", "es-PY", "es-SV", "es-US", "es-UY", "es-VE", "es"]
  });
}